<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useAuthStore } from "@core/stores/auth.store"

// ================================
// LAYOUT
// ================================
// Shell plein écran avec header de navigation (sans sidebar).
const authStore = useAuthStore()
</script>

<template>
    <div class="layout-header flex h-full min-h-0 flex-col min-w-0">
        <header class="sticky top-0 z-[1100] shrink-0">
            <HeaderNavigation />
            <BannerPastDuePayment v-if="authStore.hasUnpaidSubscriptions" />
        </header>
        <main class="min-h-0 min-w-0 flex-1 overflow-auto">
            <RouterView />
        </main>
    </div>
</template>
